import { Flex, Text } from '@chakra-ui/react'

import Card from '../Card/Card'
import CardBody from '../Card/CardBody'
import CardFooter from '../Card/CardFooter'
import CardHeader from '../Card/CardHeader'

interface Props {
    title: string,
    footer?: string,
    children: React.ReactNode
}

const FormCard = ({ title, footer, children }: Props) => {
    return (
        <Flex
            direction="column"
            w="full"
            align="center"
        >
            <Card w={{ lg: "100%", xl: "50%" }}>
                <CardHeader mb="40px">
                    <Flex w="full" justifyContent="space-between" alignItems="center">
                        <Text>{title}</Text>
                    </Flex>
                </CardHeader>
                <CardBody>
                    {children}
                </CardBody>
                <CardFooter>
                    {footer}
                </CardFooter>
            </Card>
        </Flex>
    )
}

export default FormCard